import { GetterTree } from 'vuex';
import { IFieldState } from '@signing-page/fields/store/field.store';
import { IField } from '@/dealroom/fields/types/field';
import { FieldPlacementHelper } from '@/dealroom/fields/helpers/field-placement.helper';
import { IRootState } from '@signing-page/store/store';

export const getterPositionedFields = 'positionedFields';

export const getters: GetterTree<IFieldState, IRootState> = {
  [getterPositionedFields](state): IField[] {
    return state.fields.map((field: IField) => ({
      ...field,
      position: FieldPlacementHelper.calculateFieldPositionForPlacement(
        field.position,
        state.pageWidth
      ),
    }));
  },
};
